import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import PlainInput from '../../Common/PlainInput';
const RadioFieldsAndLabel = (props) => {
    const { input, label, meta, values } = props;
    const { name } = input;
    return (_jsxs("div", Object.assign({ className: 'form form-solution cf req' }, { children: [_jsx("h3", { children: label }), _jsx("div", Object.assign({ className: 'inline-radio is-half-one' }, { children: values.map(({ label: radioLabel, value }) => (_jsxs("div", { children: [_jsx(PlainInput, { checked: input.value.toString() === value.toString(), className: '', id: `${name}_${value}`, input: input, meta: meta, type: 'radio', value: value.toString() }), _jsx("label", Object.assign({ htmlFor: `${name}_${value}` }, { children: radioLabel }))] }, value))) }))] })));
};
RadioFieldsAndLabel.propTypes = {
    input: propShape().isRequired,
    label: propStr().isRequired,
    meta: propShape().isRequired,
    values: propArrayShape().isRequired,
};
export default RadioFieldsAndLabel;
